import './image-slider.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

class ImageSlider {
    constructor (element) {
        // Elements
        this.$slider = element;
        this.$prevButton = this.$slider.querySelector('.swiper-button-prev');
        this.$nextButton = this.$slider.querySelector('.swiper-button-next');
        this.$pagination = this.$slider.querySelector('.swiper-pagination');

        // Properties
        this.slider = null;
    }

    init () {
        this.initSlider();
    }

    initSlider () {
        this.slider = new Swiper(this.$slider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 1,
            speed: 500,
            a11y: {
                prevSlideMessage: window.translations.slider.prevSlideMessage,
                nextSlideMessage: window.translations.slider.nextSlideMessage,
                firstSlideMessage: window.translations.slider.firstSlideMessage,
                lastSlideMessage: window.translations.slider.lastSlideMessage,
                slideLabelMessage: window.translations.slider.slideLabelMessage
            },
            pagination: {
                el: this.$pagination,
                type: 'progressbar'
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            }
        });
    }
}

export { ImageSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $imageSlider = $context.querySelectorAll('[data-image-slider="root"]');
        for (let i = 0; i < $imageSlider.length; i++) {
            const $slider = new ImageSlider($imageSlider[i]);
            $slider.init($imageSlider[i]);
        }
    }
});
